import { MarketingCenteredText } from "../../components/MarketingCenteredTextBlock"
import { MarketingFooter } from "../../components/MarketingFooter"
import { MarketingMenu } from "../../components/MarketingMenu"
import { MarketingOGTags } from "../../components/MarketingOGTags"
import { GenericGridDesktop, MarketingTextSVGHeader } from "../../components/MarketingTextSVGHeader"
import { FadeUpContainer } from "../../components/ReusableStyledComponents/FadeUp"
import { InlineLink } from "../../components/ReusableStyledComponents/InlineLink"
import { Body } from "../../components/Typography"
import { VerticalSpacing } from "../../components/VerticalSpacing"
import { theme } from "../../theme/theme"

export const ImprintPageLayout = () => {
    return <>
        <MarketingOGTags />
        <MarketingMenu />
        <FadeUpContainer>
            <VerticalSpacing top={20} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 50 }]}>
                <MarketingTextSVGHeader
                    title={<>Imprint</>}
                    desktopSVG={<GenericGridDesktop />}
                    mobileSVG={<></>}
                    textMaxWidth={750}
                    containerMaxWidth={1320}
                    textMarginTop={50}
                />
            </VerticalSpacing>
            <VerticalSpacing top={30} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: -90 }]}>
                <MarketingCenteredText
                    title={""}
                    punchline={<></>}
                    description={<>
                        <VerticalSpacing bottom={32}>
                            <Body>
                                Authory GmbH
                                <br />
                                David-Gilly-Straße 1
                                <br />
                                14469 Potsdam
                            </Body>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32}>
                            <Body>
                                Managing Director: Eric Hauch
                                <br />
                                Amtsgericht Potsdam
                                <br />
                                HRB 34531 P
                                <br />
                                VAT-ID No.: DE339950352
                            </Body>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32}>
                            <Body>
                                <InlineLink href="mailto:hello@authory.com">hello@authory.com</InlineLink>
                            </Body>
                        </VerticalSpacing>
                        <VerticalSpacing bottom={32}>
                            <Body>
                                Authory™ and Content Footprint™ are registered trademarks of Authory GmbH.
                            </Body>
                        </VerticalSpacing>
                    </>}
                />
            </VerticalSpacing>
            <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                <MarketingFooter />
            </VerticalSpacing>
        </FadeUpContainer>
    </>
}